
import { useCallback, useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import strings from '../../../../../../common/Translation/Translate';
import Config from '../../../../../../utils/Config';
import axiosInstance from '../../../../../../utils/axios';
import { URLS } from '../../../../../../utils/constants/urls';
import AddEdit from '../../../../CommonPage/AddEdit';
import { Box } from '@mui/material';
import { MediaInfoForm } from './MediaInfoForm';
import { saveToStorage } from 'utils/storage';

type MediaInfoTabProps = {
    setTabValue: any;
}
export const MediaInfoTab = ({ setTabValue }: MediaInfoTabProps) => {
    const { id } = useParams() as any;
    const [pageResponse, setPageResponse] = useState<any>({});
    const [logoDeleteFile, setLogoDeleteFile] = useState<any>([]);
    const [imageDeleteFile, setImageDeleteFile] = useState<any>([]);



    const getPageData = useCallback(async () => {
        try {
            const pageId = id;
            const { data } = await axiosInstance.get(URLS.getOrgMediaInfoById(pageId));

            const logo = [];
            if (data?.organizationLogo) {
                const logoObject = {
                    id: pageId,
                    name: data?.organizationLogoFileName != null ? data?.organizationLogoFileName : 'logo',
                    type: data?.organizationLogoFileType != null ? data?.organizationLogoFileType : 'img/jpg',
                    preview: Config.BaseURL + data?.organizationLogo || '',
                };
                logo.push(logoObject);
            }

            const newFile = [];
            if (data?.image) {
                const files = {
                    id: pageId,
                    name: data?.imageFileName != null ? data?.imageFileName : 'Image',
                    type: data?.imageFileType != null ? data?.imageFileType : 'img/jpg',
                    preview: data?.image ? Config.BaseURL + data?.image : null,
                };
                newFile.push(files);
            }
            setPageResponse({
                ...data,
                image: newFile,
                organizationLogo: logo,
            });
        } catch (error: any) {
            console.log(error);
        }
    }, [id]);

    useEffect(() => {
        (async () => {
            if (id) {
                await getPageData();
            }
        })();
    }, [getPageData, id]);

    const pageConfig = {
        title: id ? strings.organization_text_edit_org : strings.organization_text_add_org,
        successMessage: id ? strings.common_update_message : strings.common_save_message,
        addEditApiUrl: URLS.getOrgMediaInfoById(id),
        formModel: MediaInfoForm(),
        navigateToPage: '',
        isCustomResponse: true,
        isFormData: false,
        hideClose: true
    };
    console.log(logoDeleteFile, pageResponse)
    const deleteImages = (key: string, value: string, formData: any, isDeleted: any) => {
        if (Array.isArray(isDeleted) && isDeleted[0].id) {
            const name = isDeleted[0].name;
            switch (key) {
                case 'organizationLogo':
                    setLogoDeleteFile(name);
                    setPageResponse({ ...pageResponse, organizationLogo: '' });
                    break;
                case 'image':
                    setImageDeleteFile(name);
                    setPageResponse({ ...pageResponse, image: '' });
                    break;
                default:
                    break;
            }
        }
    };
    const handleCustomResponse = (custom: any) => {
        const body = new FormData();

        const getCustomValueTwo = (key: any) => custom[key] || pageResponse[key];
        if (getCustomValueTwo('image')) {
            getCustomValueTwo('image').forEach((file: any) => {
                body.append('image', file);
            });
        } else {
            body.append('image', null as any);
        }

        if (getCustomValueTwo('organizationLogo')) {
            getCustomValueTwo('organizationLogo').forEach((file: any) => {
                body.append('organizationLogo', file);
            });
        } else {
            body.append('organizationLogo', null as any);
        }
        body.append('deletedOrganizationLogo', logoDeleteFile);
        body.append('deletedImage', imageDeleteFile);
        return body;
    };
    const handleFormChange = (key: string, value: any, formData: any, isDeleted: any, formRef: any, setHasError: any) => {
        deleteImages(key, value, formData, isDeleted);
    };
    const customCallbackResponse = (data: any) => {
        setTabValue(2);
        saveToStorage('orgTabValue', '2')
    };

    return (
        <Box py={1}>
            <AddEdit
                customCallbackResponse={customCallbackResponse}
                handlePropsChange={handleFormChange}
                pageConfig={pageConfig}
                pageResponse={pageResponse}
                handleCustomResponse={handleCustomResponse as any}>
            </AddEdit>
        </Box>
    )
}